import { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { subscribeProducts } from "../lib/firestoreProducts";

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "adult", label: "Adult" },
  { key: "kids", label: "Kids" },
  { key: "limited", label: "Limited" },
  { key: "apparel", label: "Apparel" },
];

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";

  useEffect(() => {
    const unsub = subscribeProducts((items) => setProducts(items));
    return () => unsub();
  }, []);

  const visible = useMemo(
    () => (active === "all" ? products : products.filter((p) => p.category === active)),
    [products, active]
  );

  return (
    <div className="pt-24 md:pt-32 px-6 md:px-12 pb-24" data-testid="shop-page">
      <div className="max-w-7xl">
        <div className="label-eyebrow mb-6">The Shop · {visible.length} pieces</div>
        <h1 className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.95]">
          Every piece, equally obsessed over.
        </h1>

        <div className="mt-10 md:mt-14 flex flex-wrap gap-2 border-b border-black/10 pb-6">
          {CATEGORIES.map((c) => (
            <button
              key={c.key}
              data-testid={`filter-${c.key}`}
              onClick={() => {
                if (c.key === "all") setParams({});
                else setParams({ category: c.key });
              }}
              className={`px-4 py-2 text-sm tracking-wide transition-colors ${
                active === c.key
                  ? "bg-black text-white"
                  : "border border-black/20 hover:border-black"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 md:gap-10">
          {visible.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>

        {visible.length === 0 && (
          <div className="py-32 text-center text-black/50">No pieces in this collection yet.</div>
        )}
      </div>
    </div>
  );
}
